import React from "react";
import { View } from "react-native";
import Box from "@mui/material/Box";
import MuiModal from "@mui/material/Modal";

import { IconButton } from "../styled";
import { PopOverProps, Size } from "./types";

const style = (size: Size) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90%",
    ...(size === "sm" && { sm: 328 }),
    ...(size === "md" && { md: 640 }),
  },
  maxHeight: "90vh",
  bgcolor: "white",
  borderRadius: 5,
  overflowY: "auto",
  overflowX: "hidden",
  outline: "none",
});

export default function PopOver({
  visible,
  onDismiss,
  children,
  showCloseIcon,
  dismissable = true,
  size = "sm",
}: PopOverProps) {
  return (
    <MuiModal
      open={visible}
      onClose={(_, reason: string) => {
        if (reason === "backdropClick" && !dismissable) {
          return;
        } else {
          onDismiss();
        }
      }}
    >
      <Box sx={style(size)}>
        <View className="bg-white p-6 rounded-2xl self-center">
          {showCloseIcon && <IconButton icon="x" className="absolute top-2 left-2" onPress={onDismiss} />}
          {children}
        </View>
      </Box>
    </MuiModal>
  );
}
